import { useMemo } from 'react';
import { useTribalContext } from '../context/tribal';
import { formatCurrency } from '../modules/utils/currency';

export enum FeatureStatus {
  NOT_AVAILABLE = 'not_available',
  NOT_INCLUDED = 'not_included',
  STANDARD = 'standard',
  STANDARD_SPEC = 'standard-spec',
  OPTIONAL_EXTRA = 'optional-extra',
  REPLACED = 'replaced',
}

interface UseFeaturesHelpers {
  getSpecItemLabel: (availability: string, price?: number) => string;
}

export const useFeatures = () => {
  const { contentManager } = useTribalContext();

  return useMemo<UseFeaturesHelpers>(
    () => ({
      getSpecItemLabel: (availability: string, price?: number) => {
        if (availability === FeatureStatus.NOT_AVAILABLE) {
          return contentManager.get('not-available-feature-label');
        } else if (availability === FeatureStatus.NOT_INCLUDED) {
          return contentManager.get('not-included-feature-label');
        } else if (
          availability === FeatureStatus.STANDARD ||
          availability === FeatureStatus.STANDARD_SPEC
        ) {
          return contentManager.get('standard-feature-label');
        } else if (
          availability === FeatureStatus.OPTIONAL_EXTRA &&
          (price === null || price === undefined)
        ) {
          return contentManager.get('optional-feature-label');
        } else if (
          availability === FeatureStatus.REPLACED
        ) {
          return contentManager.get('replaced-by-added-extras-label');
        }

        return formatCurrency(price || 0);
      },
    }),
    []
  );
};
